// Orchestrates the existing sync protocol; each page is committed independently.
// The cursor only advances when every page has been durably saved.
export async function pullAllPages({ getPage, savePage, commitCursor, since = null }) {
  let offset = 0;
  let startedAt;
  let lastPage;
  do {
    const response = await getPage({ since, offset });
    if (!startedAt) {
      startedAt = response?.server_timestamp;
      if (!startedAt || !Number.isFinite(Date.parse(startedAt))) {
        throw new Error('Mise à jour sans horodatage serveur valide');
      }
    }
    await savePage(response);
    lastPage = response;
    const pagination = response?.pagination;
    if (!pagination?.has_more) break; // Legacy/demo responses are a single page.
    const next = pagination.next_offset;
    if (!Number.isInteger(next) || next <= offset) {
      throw new Error('La pagination de la mise à jour ne progresse pas');
    }
    offset = next;
  } while (true);
  await commitCursor(startedAt);
  return { ...lastPage, server_timestamp: startedAt };
}
